import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';
import React from 'react';
import { ToastOptions } from 'react-toastify';
import styled from 'styled-components';
import THEME, { COLOR } from '../../styles/colors';
import Icon from '../../ui/Icon/Icon';

// Example of how this has been done by others
// Note: We introduced the default styles and the wrapper Toast component into their model.
// https://github.com/getfider/fider/pull/645/files
const toastify = () => import(/* webpackChunkName: "toastify" */ './Toastify');

// Ryan: Couldn't get the NextJS way of doing this to work right overall, but especially in the context of TS
// const toastify = async (): Promise<typeof import('./Toastify')> =>
//   // @ts-ignore
//   dynamic(() => import('./Toastify') as any, { ssr: false });

export enum ToastMode {
  Success = 'success',
  Error = 'fail'
}

// Ryan: I suspect most of this can all be handled by the Toast API but I don't want to manage that refactor right now.
const StyledToast = styled.div<{ $mode: ToastMode }>`
  display: flex;
  align-items: center;

  .icon-container {
    background-color: ${({ $mode }) =>
      $mode === ToastMode.Success
        ? THEME.status.positive
        : THEME.status.negative};
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    height: 34px;
    width: 34px;
    border: 2px solid ${COLOR.white};
    border-radius: 100%;
    margin-right: 12px;
    min-width: 34px;
  }
`;

interface IToastProps {
  text: string;
  mode: ToastMode;
}

const Toast: React.FC<IToastProps> = ({ text, mode }) => (
  <StyledToast $mode={mode}>
    <div className="icon-container">
      <Icon
        icon={mode === ToastMode.Success ? faCheck : faTimes}
        size={18}
        color={COLOR.white}
      />
    </div>
    {text}
  </StyledToast>
);

let defaultToastOptions: ToastOptions;
export const setDefaultToastOptions = (value: ToastOptions) => {
  defaultToastOptions = value;
};

/**
 * Custom wrapper around toast to inject our own <Toast> component
 * Available options can be found here - https://www.npmjs.com/package/react-toastify
 * @param text
 * @param mode
 * @param options
 * @returns
 */
export const displayToastMessage = (
  text: string,
  mode: ToastMode = ToastMode.Success,
  options: ToastOptions | undefined = undefined
) =>
  toastify().then(toast => {
    toast.content(<Toast text={text} mode={mode} />, {
      ...(defaultToastOptions || {}),
      ...(options || {})
    });
  });

// export const success = (
//   content: string | JSX.Element,
//   options: ToastOptions | undefined = undefined
// ) =>
//   toastify().then(toast => {
//     toast.success(content, options);
//   });

// export const error = (
//   content: string | JSX.Element,
//   options: ToastOptions | undefined = undefined
// ) =>
//   toastify().then(toast => {
//     toast.error(content, options);
//   });
